<template>
	<article class="comment" :class="[mode, {'comment-manager': Number(item.manager) == 1}, {'comment-child': Number(item.parent_id) != 0}]">
		<div class="comment-col comment-content">
			<div class="comment-header">
				<template v-if="!Number(item.parent_id) != 0">
					<span v-if="item.rate" class="cp-rate comment-rate fz0">
						<span v-for="i in 5" :key="i" class="icon-star-empty" :class="{'icon-star': i <= item.rate}"></span>
					</span>
					<span class="comment-username">{{ item.display_name }}</span>
					<BaseCmsLabel v-if="item.verified_buyer" code="comment_verified_buyer" class="comment-verified-buyer" tag="div" />
				</template>
				<template v-else>
					<span class="comment-username comment-username-replay">Prima Farmacia</span>
				</template>
				<span class="comment-date"><BaseUtilsFormatDate :date="item.datetime_created" format="DD.MM.YYYY." /></span>
			</div>

			<div class="comment-message">{{ item.message }}</div>
			<div class="comment-attachments" v-if="mode != 'pd'">
				<div class="comment-images" v-if="item.image_1_upload_path" v-interpolation>
					<a :href="item.image_1_upload_path" class="fancybox"><BaseUiImage :src="item.image_1_upload_path" /></a>
					<a v-if="item.image_2_upload_path" :href="item.image_2_upload_path" class="fancybox"><BaseUiImage :src="item.image_2_upload_path" /></a>
					<a v-if="item.image_3_upload_path" :href="item.image_3_upload_path" class="fancybox"><BaseUiImage :src="item.image_3_upload_path" /></a>
					<a v-if="item.image_4_upload_path" :href="item.image_4_upload_path" class="fancybox"><BaseUiImage :src="item.image_4_upload_path" /></a>
					<a v-if="item.image_5_upload_path" :href="item.image_5_upload_path" class="fancybox"><BaseUiImage :src="item.image_5_upload_path" /></a>
				</div>
				<div class="comment-video">
					<video controls="true" playsinline v-if="item.video_upload_path">
						<source :src="config.host + item.video_upload_path" type="video/mp4">
					</video>
				</div>
			</div>
			
			<div class="comment-footer">
				<BaseFeedbackCommentReview :comment="item" v-slot="{status, rateUp, rateDown, positiveReviews, negativeReviews}">
					<div class="comment-footer-top" v-if="mode != 'pd'">
						<BaseCmsLabel code="comment_review_useful" class="comment-review-useful" tag="div" />
						<div class="review-rates up" @click="rateUp">{{positiveReviews}}</div>
						<div class="review-rates down" @click="rateDown">{{negativeReviews}}</div>
						<div class="review-rate-status" v-if="status"><BaseCmsLabel :code="status" /></div>
						<div v-if="canReplay" class="comment-reply" @click="modal.open('comment', {parent_comment_id: item.id})"><BaseCmsLabel code="comment_reply" default="Odgovori" /></div>
					</div>
				</BaseFeedbackCommentReview>
			</div>
		</div>
	</article>
</template>

<script setup>
	const modal = useModal();
	const props = defineProps(['item', 'mode']);
	const {getUser} = useAuth();
	const config = useAppConfig();
	const canReplay = computed(() => {
		const user = getUser();
		return (Number(props.item.parent_id) == 0 && (user?.staff || user?.superuser || user?.developer));
	})
</script>

<style lang="less" scoped>
	.cd-comment{
		border-top: 1px solid var(--borderColor); border-bottom: 1px solid var(--borderColor); padding: 12px 0 13px; margin-top: -1px;
		&:last-child{border-bottom: 0;}
		@media (max-width: @t){padding: 10px 0 13px;}
		@media (max-width: @m){width: calc(~"100% - -30px"); margin-left: -15px; padding: 10px 16px 13px;}
	}
	.comment-header{
		padding-bottom: 8px;
		@media (max-width: @t){padding-bottom: 4px;}
		@media (max-width: @m){flex-wrap: wrap; padding-bottom: 2px;}
	}
	.cp-rate{
		margin-right: 6px; margin-top: -3px;
		span{
			width: 16px; height: 16px;
			&:after{width: 16px; height: 16px;}
		}
		@media (max-width: @m){
			margin-right: 5px;
			span{
				width: 12px; height: 12px;
				&:after{width: 142px; height: 12px;}
			}
		}
	}
	.comment-username{
		font-weight: bold;
		@media (max-width: @m){font-size: 16px;}
	}
	.comment-verified-buyer{
		font-size: 12px; line-height: 16px; color: var(--primaryColor); font-weight: bold; text-transform: uppercase; position: relative; margin-left: 8px; padding-left: 20px;
		&:before{.pseudo(16px,16px); .icon-checkmark-footer(); font: 7px/1 var(--fonti); color: #fff; display: flex; align-items: center; justify-content: center; background: var(--primaryColor); left: 0; top: -1px; border-radius: 200px;}
		@media (max-width: @m){
			margin-left: 6px;
			&:before{font-size: 6px; padding-bottom: 1px;}
		}
	}
	.comment-date{
		margin-left: auto; font-size: 14px; line-height: 18px; color: var(--textColor); font-weight: normal;
		@media (max-width: @m){width: 100%; margin-left: unset; margin-top: 2px;}
	}
	.comment-message{font-size: 16px; line-height: 21px; font-weight: normal;}
	.comment-attachments{font-size: 0; line-height: 0;}
	.comment-images{
		display: flex; align-items: center; gap: 10px; margin-top: 10px;
		a{display: flex; align-items: center; width: calc(100% / 5);}
		:deep(img){height: auto;}
		@media (max-width: @m){margin-top: 12px; gap: 6px;}
	}
	.comment-video{
		margin: 10px 0 6px; width: 100%;
		video{width: auto; max-width: 100%;}
		@media (max-width: @m){margin: 6px 0 0;}
	}
	
	.comment-footer{
		position: relative; display: block; margin-top: 10px;
		@media (max-width: @m){margin-top: 12px;}
	}
	.comment-footer-top{display: flex; align-items: center; font-size: 14px; line-height: 19px; font-weight: normal;}
	.review-rates{
		margin-left: 8px; line-height: 13px; padding-left: 19px; position: relative; cursor: pointer;
		&:before{.icon-thumbs-up(); font: 15px/1 var(--fonti); color: var(--primaryColor); opacity: 0.2; position: absolute; left: 0; top: -3px;}
		@media (max-width: @m){margin-left: 6px;}
	}
	.down{
		margin-left: 30px;
		&:before{.rotate(180deg); top: 0px;}
		@media (max-width: @m){margin-left: 26px;}
	}
	.review-rate-status{margin-left: 8px; font-size: 12px;}
	
	//REPLAY
	.comment-reply{
		margin-left: auto; font-size: 14px; line-height: 1; padding-left: 18px; position: relative; text-decoration: underline; cursor: pointer;
		&:before{.icon-replay(); font: 11px/1 var(--fonti); position: absolute; left: 0; top: 1px; color: var(--textColor);}
	}
	.comment-username-replay{
		padding-left: 44px; position: relative;
		&:before{.pseudo(36px,20px); left: 0; top: 0; background: url(assets/images/logo-comment.svg) no-repeat; background-size: contain;}
		@media (max-width: @m){
			padding-left: 41px;
			&:before{width: 32px; height: 18px;}
		}
	}



	.cd-best-comment{
		border: 1px solid var(--primaryColor)!important; padding: 12px 16px 13px; margin-bottom: 16px;
		@media (max-width: @t){padding: 10px 12px 13px; margin-bottom: 10px;}
		@media (max-width: @m){width: 100%; margin-left: 0;}
	}
</style>